import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Wizard from 'components/webrtc-validator/wizard';

class WebRtcValidator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _session: null,
    };
  }

  render() {
    return (
        <Wizard />
    );
  }
}


document.addEventListener('DOMContentLoaded', () => {
  $(".start-test").click(function(e){
    e.preventDefault();
    try {
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      window.audioContext = new AudioContext();

      const container = document.getElementById("webrtc-validator");
      if(container){
        $(".test-instructions").addClass("d-none");
        ReactDOM.render(
            <WebRtcValidator />,
            container.appendChild(document.createElement('div')),
        )
      }
    } catch (e) {
      console.log('Failed to instantiate an audio context, error: ' + e);
    }
    return false;
  });


  window.appendSourceId = function(id, type, constraints) {
    if (constraints[type] === true) {
      constraints[type] = {optional: [{sourceId: id}]};
    } else if (typeof constraints[type] === 'object') {
      if (typeof constraints[type].optional === 'undefined') {
        constraints[type].optional = [];
      }
      constraints[type].optional.push({sourceId: id});
    }
  };

  window.doGetUserMedia = function(sourceId, constraints, onSuccess, onFail) {
    var self = this;
    try {
      // Append the constraints with the getSource constraints.
      if (constraints["audio"]) {
        appendSourceId(sourceId, 'audio', constraints);
      } else {
        appendSourceId(sourceId, 'video', constraints);
      }
      // Call into getUserMedia via the polyfill (adapter.js).
      navigator.mediaDevices.getUserMedia(constraints)
          .then(function(stream) {
            var cam = getDeviceName_(stream.getVideoTracks());
            var mic = getDeviceName_(stream.getAudioTracks());
            console.log({'status': 'success', 'camera': cam, 'microphone': mic});
            onSuccess.apply(this, arguments);
          })
          .catch(function(error) {
            console.log({'status': 'fail', 'error': error});
            if (onFail) {
              onFail.apply(this, arguments);
            } else {
              console.log('Failed to get access to local media due to ' + 'error: ' + error.name);
            }
          });
    } catch (e) {
      console.log({'status': 'exception', 'error': e.message});
    }
  };

  // Return the first device label on the track.
  window.getDeviceName_ = function(tracks) {
    if (tracks.length === 0) {
      return null;
    }
    return tracks[0].label;
  };

  /*window.setTimeoutWithProgressBar = function(timeoutCallback, timeoutMs) {
    var start = window.performance.now();
    var updateProgressBar = setInterval(function() {
      var now = window.performance.now();
      console.log((now - start) * 100 / timeoutMs);
    }, 100);
    var timeoutTask = function() {
      clearInterval(updateProgressBar);
      console.log(100);
      timeoutCallback();
    };
    var timer = setTimeout(timeoutTask, timeoutMs);
    var finishProgressBar = function() {
      clearTimeout(timer);
      timeoutTask();
    };
    return finishProgressBar;
  }*/
});
